import React, { Component } from 'react';

//componentes
import CorreosMasivos from './correosMasivos'

class Index extends Component {

    render(){
        return(
            <div>
                <CorreosMasivos />
            </div>
        );
    }
}
export default Index;